import { SchoolEngagementQuery, SchoolEngagementQueryVariables } from '@/graphql/generated/graphql';
import { SCHOOL_ENGAGEMENT } from '@/graphql/queries/report/ga-interactions';
import { useQuery } from '@apollo/client';
import { useDashboardStore } from '../../../store/useDashboardStore';

export default function EngamentPastWeek() {
  const { schoolsIds } = useDashboardStore();
  const { data, loading } = useQuery<SchoolEngagementQuery, SchoolEngagementQueryVariables>(SCHOOL_ENGAGEMENT, {
    variables: {
      schoolsIds,
    },
  });

  const renderArrowUp = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M20.4766 10.1627L12.6016 2.40022C12.2641 2.06272 11.7391 2.06272 11.4016 2.40022L3.52656 10.1627C3.18906 10.5002 3.18906 11.0252 3.52656 11.3627C3.86406 11.7002 4.38906 11.7002 4.72656 11.3627L11.1391 5.06272V21.0002C11.1391 21.4502 11.5141 21.8252 11.9641 21.8252C12.4141 21.8252 12.8266 21.4502 12.8266 21.0002V4.98772L19.3141 11.3627C19.4641 11.5127 19.6891 11.5877 19.9141 11.5877C20.1391 11.5877 20.3641 11.5127 20.5141 11.3252C20.8141 11.0252 20.8141 10.4627 20.4766 10.1627Z"
          fill="#1775E3"
        />
      </svg>
    );
  };

  const renderArrowDown = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
          d="M21.2266 12.6753C20.8891 12.3378 20.3641 12.3378 20.0266 12.6753L13.6141 18.9753V3.00029C13.6141 2.55029 13.2391 2.17529 12.7891 2.17529C12.3391 2.17529 11.9641 2.55029 11.9641 3.00029V19.0128L5.47656 12.6378C5.13906 12.3003 4.61406 12.3003 4.27656 12.6378C3.93906 12.9753 3.93906 13.5003 4.27656 13.8378L12.1516 21.6003C12.3016 21.7503 12.5266 21.8253 12.7516 21.8253C12.9766 21.8253 13.1641 21.7503 13.3516 21.6003L21.2266 13.8378C21.5641 13.5378 21.5641 12.9753 21.2266 12.6753Z"
          fill="#F07167"
        />
      </svg>
    );
  };

  const renderEngament = () => {
    if (data?.getSchoolEngagement.percentage === 0) return 'No change';
    if (!data?.getSchoolEngagement.percentage) return '-';
    return (
      <>
        {data?.getSchoolEngagement.percentage}%{' '}
        {data?.getSchoolEngagement.increased ? renderArrowUp() : renderArrowDown()}
      </>
    );
  };

  if (loading) {
    return (
      <p>
        <div className="size-10 animate-pulse rounded-md bg-gray-300"></div>
      </p>
    );
  }

  return (
    <>
      <p className=" flex items-center gap-2  text-sh-md font-bold"> {renderEngament()}</p>
    </>
  );
}
